module.exports = __webpack_public_path__ + "static/media/mansour.4b4dc831.jpeg";